import deviceMemo from './deviceMemo.vue'
export default deviceMemo
